// extracted by mini-css-extract-plugin
export default {"home-container":"Home_home-container__sCZWl","title":"Home_title__XLxL1","slide-up":"Home_slide-up__U9Ptj","home":"Home_home__Iy41P"};